import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ApiCollectionResponse,
  ApiSingleResponse,
} from '../../interfaces/responses/api-response';

/** Document du dossier élève, tel que l'API le renvoie. */
export interface StudentDocument {
  id: number;
  title: string;
  description?: string | null;
  category: string;
  fileName: string;
  fileSizeBytes?: number | null;
  contentType?: string | null;
  uploadedAt: string;
  documentDate?: string | null;
}

/**
 * Bulletins scolaires de l'élève connecté.
 *
 * Routes sans identifiant : le serveur lit l'élève dans le jeton. Les endpoints
 * génériques `api/student-files` acceptent un identifiant sans vérifier la
 * propriété — les utiliser ici exposerait le dossier des autres élèves.
 */
@Injectable({ providedIn: 'root' })
export class ReportCardService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.BASE_URL}/students/me/report-cards`;

  list(): Observable<ApiCollectionResponse<StudentDocument>> {
    return this.http.get<ApiCollectionResponse<StudentDocument>>(this.base);
  }

  /**
   * Dépose un bulletin. La catégorie n'est pas transmise : cette route ne
   * dépose que des bulletins, et c'est le serveur qui l'impose.
   */
  upload(file: File, title: string, documentDate?: string | null):
    Observable<ApiSingleResponse<StudentDocument>> {
    const form = new FormData();
    form.append('file', file);
    form.append('title', title);
    if (documentDate) form.append('documentDate', documentDate);

    return this.http.post<ApiSingleResponse<StudentDocument>>(this.base, form);
  }
}
